import React, {Component} from "react";
import {Icon, Modal} from "antd";
import _ from "i18n";
import {connect} from "react-redux";
import TypeFilter
  from "../../../Filters/EventStats/BudgetManagement/TypeFilter";
import AnnualTargetManagement from "./AnnualTargetManagement";
import YearFilter
  from "../../../Filters/EventStats/BudgetManagement/YearFilter";
import BudgetResult from "./BudgetResult";
import GenerateFollowUp from "./GenerateFollowUp";
import BudgetMonths from "./BudgetMonths";
import TargetBudget from "./TargetBudget";
import FollowUp from "./FollowUp";
import {
   setOriginalValues,
  updateSetUp
} from "../../../../actions/actions/eventStats";
import {
  checkAppTypesConfiguration,
  fetchBudgetData,
  updateFollowUp,
  deleteBudgetConfiguration, updateConfiguration
} from "../../../../actions/thunks/eventStats";
import {CommonLoader} from "../../../common/CommonLoader";
import {showErrorNotification} from "../../../../services/utils";
import {
  DeleteOutlined,
  EditOutlined,
  ExclamationCircleOutlined
} from "@ant-design/icons";


class BudgetManagementModal extends Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.fetchBudgetData();
    this.props.checkAppTypesConfiguration(this.props.budgetManagement.year);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {fetchBudgetData: {isError : fetchIsError}, generateFollowUp: {isError : generateIsError}, updateFollowUp: {isError : updateIsError}, appType, year, deleteBudgetConfiguration:{isError: deleteIsError}} = this.props.budgetManagement;
    const {fetchBudgetData: {isError : prevFetchIsError}, generateFollowUp: {isError : prevGenerateIsError}, updateFollowUp: {isError : prevUpdateIsError}, deleteBudgetConfiguration:{isError: prevDeleteIsError}} = prevProps.budgetManagement;

    if(prevProps.budgetManagement.year !== year){
      this.props.checkAppTypesConfiguration(this.props.budgetManagement.year);
    }

    if (prevProps.budgetManagement.appType !== appType || prevProps.budgetManagement.year !== year) {
      this.fetchBudgetData();
    }
    if ((fetchIsError === true && prevFetchIsError !== fetchIsError) || (generateIsError === true && prevGenerateIsError !== generateIsError) || (updateIsError === true && prevUpdateIsError !== updateIsError) || (deleteIsError === true && deleteIsError !== prevDeleteIsError)){
      showErrorNotification(_('error'), _('errorOccured'));
    }
  }

  fetchBudgetData = () => {
    const {budgetManagement} = this.props;
    const {year, appType} = budgetManagement;
    this.props.fetchBudgetData(year, appType);
  }

  updateFollowUp = () => {
    const {annualTargetId, followUp} = this.props.budgetManagement;
    this.props.updateFollowUp(annualTargetId, followUp);
  }

  onCancelModal = () => {
    this.props.handleModalVisibility(false);
  }
  onCancelFollowUp = () => {
    this.props.setOriginalValues();
  }

  deleteBudgetConfiguration = () =>{
    const {annualTargetId, year, appType} = this.props.budgetManagement;
    const {confirm} = Modal;
    const onOk = () => {
      this.props.deleteBudgetConfiguration(annualTargetId,year, appType);
      Modal.destroyAll();
    }

    confirm({
      title: _('DELETE_CONFIGURATION_QUESTION'),
      icon: <ExclamationCircleOutlined/>,
      okText: _("confirm"),
      cancelText: _("cancel"),
      className: 'relanceActivationModal',
      onOk,
    });

  }

  editConfig = () => {
    const {annualTargetId, followUp, globalBudget:{totalHTVA ,registrantsCount, pricePerUnit}, budgetPerMonth} = this.props.budgetManagement;
    this.props.updateConfiguration(annualTargetId, followUp, registrantsCount, pricePerUnit, totalHTVA, budgetPerMonth);
  }

  render() {
    const {budgetManagement, showTargetBudget, followUp} = this.props;
    const registrantsCounts = followUp.map((item) => item.registrantsCount);
    const pricePerUnit = followUp.map((item) => item.pricePerUnit);
    const currentYear = new Date().getFullYear();

    return (
      <Modal
        visible={true}
        width={'90%'}
        bodyStyle={{height: '620px', padding: '0'}}
        centered={true}
        wrapClassName={'create-BM-modal'}
        maskClosable={false}
        footer={(budgetManagement.isUpdatingFollowUp || budgetManagement.isUpdatingSetUp) && (
          <div className={'flex w-full'}>
            <button className={'cancel-button'}
                    onClick={this.onCancelFollowUp}>{_('cancel')}
            </button>
            <button className={'save-button ml-auto'}
                    onClick={budgetManagement.isUpdatingSetUp ? this.editConfig :this.updateFollowUp}
                    disabled={budgetManagement.updateFollowUp.processing || registrantsCounts.includes('') || pricePerUnit.includes('') || budgetManagement.updateBudgetConfiguration.processing}>
              <span>{_('save')}</span>
              {(budgetManagement.updateFollowUp.processing === true || budgetManagement.updateBudgetConfiguration.processing === true) &&
              <Icon className="ml-2" type="sync" spin/>}
            </button>
          </div>
        )}
        onCancel={this.onCancelModal}
      >
        <div className={'create-BM-header light-blue-font px-4 py-3'}>{_('MANAGE_MY_TURNOVER')}</div>
        <div className={'create-BM-filters px-4 py-3'}>
          <div className={'create-BM-nav'}>
            <YearFilter/>
            <TypeFilter/>
          </div>
        </div>
        {
          (budgetManagement.fetchBudgetData.fetching === true || budgetManagement.deleteBudgetConfiguration.processing === true) ?

            <CommonLoader containerHeight={"484px"} iconFontSize={"50px"} iconColor={"#29394D"} marginTop={"149"}/>
            : (budgetManagement.fetchBudgetData.isError === true) ?
            <div
              className={'flex items-center flex-column retry-container'}
              style={{minHeight: '484px'}}>
              <div className={'retry-label mb-3'} style={{marginTop: "139px"}}>{_('ERROR_OCCURED')}</div>
              <button type={"button"} className={'retry-button'}
                      onClick={this.fetchBudgetData}>
                {_('RETRY')}
              </button>
            </div>
          : (budgetManagement.followUp.length === 0 && (budgetManagement.appType === 'all' || budgetManagement.year < currentYear) ) ?
          <div className={'flex items-center justify-center'} style={{minHeight : '150px'}}>
          <span className={'no-data-found'}>{_('NO_CONFIG_DONE')}</span>
          </div>
          :
          <React.Fragment>

          <div className={'create-BM-main-content px-4'}>
          <div className={'create-BM-main-content-aside mr-3'}>
          <AnnualTargetManagement/>
          {
            budgetManagement.year >= currentYear &&  budgetManagement.followUp.length !== 0 &&  budgetManagement.appType !== 'all' && budgetManagement.isUpdatingSetUp === false &&
            <div className={'flex'} style={{justifyContent: 'space-between', gap: '10px' }}>
              <button key="submit" className={'notSave w-full'} style={{ backgroundColor: '#fe3745'}}
                      onClick={this.deleteBudgetConfiguration}>
                <DeleteOutlined className={'mr-1'}/>
                {_('delete')}
              </button>
              <button  className={'notSave w-full'} style={{ backgroundColor: '#ffb06a'}}
                      onClick={this.props.updateSetUp}>
                <EditOutlined className={'mr-1'}/>
                {_('EDIT')}
              </button>
            </div>
          }

          </div>

          <BudgetMonths showTargetBudget={showTargetBudget}/>
        {budgetManagement.showTargetBudget &&
          <div className={'target-budget-component'}>
          <TargetBudget isRealized={true}/>
          </div>
        }

          <div className={budgetManagement.appType === 'monthly_premium' ? 'target-budget-component-monthly-premium' : 'target-budget-component'}>
          <TargetBudget isRealized={false}/>
          </div>

          <div className={'follow-up-component'}>
        {budgetManagement.followUp.length > 0 ? (
          <FollowUp />
          ) : (
          <GenerateFollowUp/>
          )}
          </div>


        {budgetManagement.followUp.length > 0 &&
          <div className={'create-BM-main-content-budget-result ml-3'}>
          <BudgetResult type={"budget"}/>
          <hr/>
          <BudgetResult type={"adjustment"}/>
          </div>
        }
          </div>
          </React.Fragment>
        }
      </Modal>
    );
  }

}

const mapStateToProps = state => ({
  budgetManagement: state.budgetManagement,
  showTargetBudget: state.budgetManagement.showTargetBudget,
  followUp: state.budgetManagement.followUp,
});

const mapDispatchToProps = {
  setOriginalValues,
  fetchBudgetData,
  updateFollowUp,
  checkAppTypesConfiguration,
  deleteBudgetConfiguration,
  updateConfiguration,
  updateSetUp
};

export default connect(mapStateToProps, mapDispatchToProps)(BudgetManagementModal);



// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/BudgetManagement/BudgetManagementModal.js